import React from 'react';
import { Link } from 'react-router-dom';
import Icon from 'components/AppIcon';
import SignupForm from './components/SignupForm';

const FEATURES = [
  { icon: 'BarChart3', text: 'CRM analytics dashboard — live from your data' },
  { icon: 'IndianRupee', text: 'Revenue tracking in ₹ (INR)' },
  { icon: 'Users', text: 'Lead & opportunity management' },
  { icon: 'Shield', text: 'Secure, encrypted workspace' },
];

export default function Signup() {
  return (
    <div
      className="min-h-screen flex"
      style={{ background: 'var(--color-background)' }}
    >
      {/* Left panel - branding */}
      <div
        className="hidden lg:flex flex-col justify-between w-2/5 p-10"
        style={{
          background: 'linear-gradient(160deg, #0F172A 0%, #1E3A5F 60%, #1E40AF 100%)',
        }}
      >
        <div className="flex items-center gap-3">
          <div
            className="flex items-center justify-center rounded-xl"
            style={{ width: 44, height: 44, background: 'rgba(255,255,255,0.15)' }}
          >
            <Icon name="BarChart3" size={22} color="#FFFFFF" strokeWidth={2} />
          </div>
          <span className="font-heading font-bold text-xl text-white">
            CRM<span style={{ color: '#93C5FD' }}>Analytics</span>
          </span>
        </div>

        <div>
          <h2 className="font-heading font-bold text-3xl text-white mb-3" style={{ lineHeight: 1.2 }}>
            Your CRM,<br />all in one workspace
          </h2>
          <p className="font-caption text-sm mb-8" style={{ color: 'rgba(255,255,255,0.6)' }}>
            Track leads, manage pipelines, and close more deals.
          </p>

          <div className="flex flex-col gap-3">
            {FEATURES?.map((f) => (
              <div key={f?.text} className="flex items-center gap-3">
                <div
                  className="flex items-center justify-center rounded-lg flex-shrink-0"
                  style={{ width: 32, height: 32, background: 'rgba(255,255,255,0.1)' }}
                >
                  <Icon name={f?.icon} size={15} color="#93C5FD" />
                </div>
                <span className="font-caption text-sm" style={{ color: 'rgba(255,255,255,0.8)' }}>{f?.text}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="flex items-center gap-2">
          <Icon name="Shield" size={14} color="rgba(255,255,255,0.4)" />
          <span className="font-caption text-xs" style={{ color: 'rgba(255,255,255,0.4)' }}>
            256-bit SSL encrypted
          </span>
        </div>
      </div>
      {/* Right panel - form */}
      <div className="flex-1 flex items-center justify-center p-6 lg:p-10 overflow-y-auto">
        <div className="w-full max-w-md">
          {/* Mobile logo */}
          <div className="flex items-center gap-2 mb-8 lg:hidden">
            <div
              className="flex items-center justify-center rounded-lg"
              style={{ width: 36, height: 36, background: 'var(--color-primary)' }}
            >
              <Icon name="BarChart3" size={18} color="#FFFFFF" />
            </div>
            <span className="font-heading font-bold text-lg" style={{ color: 'var(--color-foreground)' }}>
              CRM<span style={{ color: 'var(--color-primary)' }}>Analytics</span>
            </span>
          </div>

          <div className="mb-7">
            <h1 className="font-heading font-bold text-2xl mb-1" style={{ color: 'var(--color-foreground)', letterSpacing: '-0.02em' }}>
              Create your account
            </h1>
            <p className="font-caption text-sm" style={{ color: 'var(--color-text-secondary)' }}>
              Start your 14-day free trial — no credit card required
            </p>
          </div>

          <SignupForm />

          <p className="text-center font-caption text-sm mt-6" style={{ color: 'var(--color-text-secondary)' }}>
            Already have an account?{' '}
            <Link
              to="/login"
              className="font-semibold transition-colors hover:underline"
              style={{ color: 'var(--color-primary)' }}
            >
              Sign in
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}
